/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Desireddegreeother2Inputs */

const en__field_desireddegreeother2 = /** @type {(inputs: _Field_Desireddegreeother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other degree`)
};

const de__field_desireddegreeother2 = /** @type {(inputs: _Field_Desireddegreeother2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiger Abschluss`)
};

/**
* | output |
* | --- |
* | "other degree" |
*
* @param {_Field_Desireddegreeother2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_desireddegreeother2 = /** @type {((inputs?: _Field_Desireddegreeother2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Desireddegreeother2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_desireddegreeother2(inputs)
	return de__field_desireddegreeother2(inputs)
});
export { _field_desireddegreeother2 as "_field_desiredDegreeOther" }